<template>
    <div>
        <b-button
            variant="primary"
            class="m-1"
            v-b-modal.createTiposDeUsuarioModal
            id="createTiposDeUsuarioButton"
        >
            Crear tipo <b-icon icon="person-badge" font-scale="1"></b-icon>
        </b-button>

        <!-- Modal tipo de usuario -->
        <b-modal id="createTiposDeUsuarioModal" title="Crear usuario" class="" size="md" centered scrollable
            header-bg-variant="dark" v-model="modalShowTypeUser" hide-footer>

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>

            </template>

            <!-- cuerpo del modal -->
             <TypeUserForm></TypeUserForm>

        </b-modal>
    </div>
</template>
<script>
import TypeUserForm from './SettingTypeUser/Type-user-form.vue'

export default {
    name: 'SettingTypeUser',

    data() {
        return {
            modalShowTypeUser: false
        }
    },

    components:{
        TypeUserForm
    },

    methods: {
        openModalTypeUser() {
            this.modalShowTypeUser = true;
        },

        closeModalTypeUser() {
            this.modalShowTypeUser = false;
        }
    }

}
</script>
<style></style>